/**
 * Layout used by every `/teacher/*` route: top bar, mock-LMS banner, side
 * navigation, and the main outlet. Kept trivial — it is a *shell*, not a
 * widget framework.
 */

import { NavLink, Outlet } from 'react-router-dom';
import { Banner } from './Banner';
import { useSession } from '../auth/SessionProvider';

const NAV_ITEMS: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/teacher/dashboard', label: 'Dashboard' },
  { to: '/teacher/courses', label: 'Courses' },
  { to: '/teacher/courseware', label: 'Courseware' },
  { to: '/teacher/grading', label: 'Grading' },
  { to: '/teacher/settings', label: 'Settings' },
];

export function TeacherShell() {
  const { session, signOut } = useSession();
  const name = session?.principal.userId ?? 'Unknown teacher';

  return (
    <div className="shell">
      <header className="shell__topbar" role="banner">
        <div className="shell__brand">
          <strong>Teacher AI Hub</strong>
          <span className="shell__brand-tag">MVP</span>
        </div>
        <div className="shell__user">
          <span aria-label="Signed-in user">{name}</span>
          <button
            type="button"
            className="btn btn--ghost"
            onClick={signOut}
            data-testid="sign-out"
          >
            Sign out
          </button>
        </div>
      </header>
      <Banner />
      <div className="shell__body">
        <nav className="shell__nav" aria-label="Teacher navigation">
          <ul>
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    isActive ? 'shell__nav-link is-active' : 'shell__nav-link'
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        <main className="shell__main" id="main-content" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
